import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";

function Dashboard ({color, classes = '', url}) {
    const navigate = useNavigate();
    const onMenuClick = () => {
        navigate(`/${url}`);
    }
    return (
        <div className={classes} onClick={onMenuClick}>
            <svg id="dashboard" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                <path id="dashboard-2" data-name="dashboard" d="M5,5V23H23V5ZM6.636,6.636h4.091v4.091H6.636Zm5.727,0h3.273v4.091H12.364Zm4.909,0h4.091v4.091H17.273ZM6.636,12.364h4.091v3.273H6.636Zm5.727,0h3.273v3.273H12.364Zm4.909,0h4.091v3.273H17.273ZM6.636,17.273h4.091v4.091H6.636Zm5.727,0h3.273v4.091H12.364Zm4.909,0h4.091v4.091H17.273Z" transform="translate(-5 -5)" fill={color}/>
            </svg>
        </div>
    );
}

export default Dashboard;
